module.exports = __webpack_public_path__ + "img/standort_pfarrei-st-martin_3.d8e54857.png";